$(document).on('shopify:section:load', function() {

    if ($('.show-up').length) {
        $('.show-up').each(function() {
            $(this).css('display', 'inline-block');

            let text = $(this).html();
            $(this).html(`<span>${text}</span>`);
        });
    }

    if ($('.collection-list').length) {
        $('.collection-list .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.parents('.collection-list').find('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 4,
                slideBy: 4,
                nav: false,
                dots: false,
                smartSpeed: 300,
                autoHeight: true,
                margin: 20,
                responsive: {
                    0: {
                        items: 3,
                        slideBy: 3,
                        margin: 10,
                    },
                    1280: {
                        items: 4,
                        slideBy: 4,
                        margin: 20,
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');

            let path = location.pathname.match(/^\/collections\/[^\/]+/);
            if (path) {
                let exists = $(`.collection-list .item[data-url="${path[0]}"]`).length;
                
                if (!exists) {
                    $('.collection-list .item').first().addClass('active');
                }
                else {
                    $(`.collection-list .item[data-url="${path[0]}"]`).addClass('active');
                }
            }

            let url = $('.collection-list .item.active').data('url');

            let currentURL = window.location.href;
            let sort = currentURL.match(/[?&]sort_by=([^&]+)/) || '';

            if (sort) {
                let sortBy = decodeURIComponent(sort[1].replace(/\+/g, ' '));
                let exists = $(`[data-sort="${sortBy}"]`).length;

                if (exists) {
                    $(`[data-sort="${sortBy}"]`).addClass('active');
                    $('[name="sort-select"]').val(sortBy).trigger('change');
                    sort = 'sort_by='+sortBy;
                }
            }

            if (typeof Shopify === 'undefined' || !Shopify.designMode) {
                if (sort)
                    getCollection(url+'?'+sort);
                else
                    getCollection(url);

                let activeIndex = $carousel.find('.owl-item').has('.item.active').index();
                $carousel.trigger('to.owl.carousel', [activeIndex, 0]);
            }
        });
    }

    if ($('.faqs').length) {
        $('.faqs').each(function() {
            let el = $(this);

            el.find('.toggle:first-child').addClass('active');
            el.find('.menu-toggle:first-child').show();
        });
    }

    setTimeout(() => {
        page_banner();
    }, 500);

    cta();
});

$(document).ready(function() {

    if ($('.show-up').length) {
        $('.show-up').each(function() {
            $(this).css('display', 'inline-block');

            let text = $(this).html();
            $(this).html(`<span>${text}</span>`);
        });
    }

    if ($('.collection-list').length) {
        $('.collection-list .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.parents('.collection-list').find('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 4,
                slideBy: 4,
                nav: false,
                dots: false,
                smartSpeed: 300,
                autoHeight: true,
                margin: 20,
                responsive: {
                    0: {
                        items: 3,
                        slideBy: 3,
                        margin: 10,
                    },
                    1280: {
                        items: 4,
                        slideBy: 4,
                        margin: 20,
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');

            let path = location.pathname.match(/^\/collections\/[^\/]+/);
            if (path) {
                let exists = $(`.collection-list .item[data-url="${path[0]}"]`).length;
                
                if (!exists) {
                    $('.collection-list .item').first().addClass('active');
                }
                else {
                    $(`.collection-list .item[data-url="${path[0]}"]`).addClass('active');
                }
            }

            let url = $('.collection-list .item.active').data('url');

            let currentURL = window.location.href;
            let sort = currentURL.match(/[?&]sort_by=([^&]+)/) || '';

            if (sort) {
                let sortBy = decodeURIComponent(sort[1].replace(/\+/g, ' '));
                let exists = $(`[data-sort="${sortBy}"]`).length;

                if (exists) {
                    $(`[data-sort="${sortBy}"]`).addClass('active');
                    $('[name="sort-select"]').val(sortBy).trigger('change');
                    sort = 'sort_by='+sortBy;
                }
            }

            if (typeof Shopify === 'undefined' || !Shopify.designMode) {
                if (sort)
                    getCollection(url+'?'+sort);
                else
                    getCollection(url);

                let activeIndex = $carousel.find('.owl-item').has('.item.active').index();
                $carousel.trigger('to.owl.carousel', [activeIndex, 0]);
            }
        });
    }

    if ($('.faqs').length) {
        $('.faqs').each(function() {
            let el = $(this);

            el.find('.toggle:first-child').addClass('active');
            el.find('.menu-toggle:first-child').show();
        });
    }

    setTimeout(() => {
        page_banner();
    }, 500);

    cta();
});

$(window).on('scroll', function() {
    page_banner();
    cta();
});

function page_banner() {
    if ($('.page-banner').length) {
        $('.page-banner').each(function() {
            let el = $(this);
            let show = el.find('.show-up');
        
            if (visiblePercent(el) > 20) {
                el.find('.bg').css('transform', 'translate(-50%, -50%) scale(1)');
                show.addClass('show');
            }
            else {
                el.find('.bg').css('transform', 'translate(-50%, -50%) scale(1.2)');
                show.removeClass('show');
            }
        });    
    }
}

function cta() {
    if ($('.cta').length) {
        $('.cta').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 20) {
                el.find('.content img').css('transform', 'translate(-50%, -50%) scale(1)');
            }
            else {
                el.find('.content img').css('transform', 'translate(-50%, -50%) scale(1.1)');
            }
        });    
    }
}

$('.faqs .toggle').on('click', function() {
    $(this).addClass('active').siblings().removeClass('active');

    let toggle = $(this).data('toggle');

    let el = $(this).parents('.faqs');

    el.find('.menu-toggle').hide();
    el.find(`.menu-toggle[data-menu="${toggle}"]`).fadeIn();
});

$('.collection-list .item').on('click', function() {
    $('.collection-list .item').removeClass('active');
    $(this).addClass('active');

    let sort = '';
    let activeSort = $('.sort-by .active');
    if (activeSort.length) {
        sort = activeSort.data('sort');
    }

    let url = $(this).data('url');

    if (sort) {
        if (url.includes('?'))
            url += '&sort_by=' + sort;
        else
            url += '?sort_by=' + sort;
    }

    getCollection(url);
});

$('.collection-list .sort-by [data-sort]').on('click', function() {
    $(this).toggleClass('active').siblings().removeClass('active');
        
    let sort = '';

    if ($(this).hasClass('active')) 
        sort = $(this).data('sort');

    let url = $(this).parents('.collection-list').find('.item.active').data('url');

    if (sort) {
        if (url.includes('?'))
            url += '&sort_by=' + sort;
        else
            url += '?sort_by=' + sort;
    }

    getCollection(url);
});

$('.collection-list [name="sort-select"]').on('change', function() {
    let sort = $(this).val();

    if (sort) 
        $(`.collection-list .sort-by [data-sort="${sort}"]`).addClass('active').siblings().removeClass('active');
    else 
        $('.collection-list .sort-by [data-sort]').removeClass('active');

    
    let url = $(this).parents('.collection-list').find('.item.active').data('url');

    if (sort) {
        if (url.includes('?'))
            url += '&sort_by=' + sort;
        else
            url += '?sort_by=' + sort;
    }

    getCollection(url);
    
});

function getCollection(url) {

    history.pushState(null, '', url);

    $('.collection-list .el-overlay').show();

    $.ajax({
        type: "GET",
        url: url,
        success: function(data) {
            $('.collection-list .product-list').html($(data).find('.product-list').html());

            let height = $('.collection-list .product-item').first().outerHeight();
            $('.collection-list .sort-by').css('min-height', `${height}px`);
        },
        error: function() {
            console.log("Error occurred while fetching collection.");
        },
    }).always(function() {
        $('.collection-list .el-overlay').fadeOut();
    });
}